import React from "react";
import Box from "@mui/material/Box";
import DashboardLeaveTrend from "../web/widgets/DashboardLeaveTrend";

export default function MobileDashboardLeaveTrend({ leaves }) {
    return (
        <Box sx={{
            "& .MuiCard-root": {
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.10)",
            }
        }}>
            <DashboardLeaveTrend
                leaves={leaves}
                compact
                title="Tendance 6 mois"
                subtitle="Demandes créées par type"
            />
        </Box>
    );
}
